export interface StockExchange {
  ID: number;
  Name: string;
  Abbrev: string;
}

export enum OwnershipType {
  Public = 'Public',
  Private = 'Private',
}
